import React from "react";
import PropTypes from "prop-types";
import { PlaceShape } from "../../../Srp/shapes";

const LinkCrumb = ({ url, place }) => (
  <a href={url} className={`kind-${place.kind.replace(/ /g, "-")}`}>
    {place.name}
  </a>
);

LinkCrumb.propTypes = {
  url: PropTypes.string.isRequired,
  place: PlaceShape.isRequired,
};

export default LinkCrumb;
